import React, { useMemo } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { selectAllOfficeEntities } from "@features/desks/store/advanceHotDeskingSetup.duck";
import { selectedOffice } from "../../../../store/officeView.duck";
import { getFullOfficeTitleById } from "@shared/utils/OfficeHelper";
import styled from "styled-components";
import DateFlicker, { DateScale } from '@shared/ui/molecules/DateFlicker';
import { PRETTY_DATE_FORMAT } from "@shared/utils/DateUtils";
import { Moment } from "moment";
import { selectActiveDay, setActiveDay } from "../../../../store/editMovements.duck";
import { OutlineButton } from '@shared/ui/atoms/buttons/OutlineButton';
import { PageTitle } from '@shared/ui/atoms/PageTitle';
import { desktop, tablet } from '@shared/ui/atoms/MediaQueries';
import { DialogIdentifiers, openDialog } from "@shared/store/dialog.duck";

export function FloorMapHeader(props: Props) {
  const office = useSelector(selectedOffice);
  const allOffices = useSelector(selectAllOfficeEntities);
  const activeDay = useSelector(selectActiveDay);
  const dispatch = useDispatch();

  const officeLabel = useMemo(() => {
    if (!office) return '';
    return getFullOfficeTitleById(office.id, allOffices)
  }, [allOffices, office]);

  return (
    <Wrapper>
      <Container>
        <ContentWrapper>
          <OfficeInfo>
            <PageTitle overrideText={officeLabel} text={'office-map.select-office'} />
            <ChangeOfficeButton text={'button.change-office'} size={"small"}
                                click={() => dispatch(openDialog(DialogIdentifiers.ChangeOfficeDialog))} />
          </OfficeInfo>
          <DateFlicker dateScale={DateScale.Day}
                       onChange={(date: Moment) => dispatch(setActiveDay(date))}
                       updateGlobalDate={true}
                       restrictPastWhereabouts={true}
                       date={activeDay}
                       showDate={true} className={'floorMapHeader__datePicker'}
                       dateInTheMiddle={true}
                       dateFormat={PRETTY_DATE_FORMAT} />
        </ContentWrapper>
      </Container>
    </Wrapper>
  )
}

interface Props {
  onSideBarOpen: (val: boolean) => void;
}

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  h3 {
    margin-top: 16px;
  }
  .floorMapHeader__datePicker {
    margin-top: 16px;
    @media (${desktop}) {
      align-self: center;
    }
  }
  @media (${desktop}) {
    margin-top: 0;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0 0 12px 0;
    .floorMapHeader__datePicker {
      align-self: flex-end;
      margin-top: 0;
    }
    .pageTitle {
      margin-left: 0;
      margin-right: 0;
      margin-bottom: 0;
    }
    h3 {
      margin-top: 0;
    }
    .floorMapHeader__sideBarButton {
      display: none;
    }
    .weekFlicker__control {
      padding: 0 !important;
    }
  }
`

const Container = styled.div`
  padding: 0 16px;
  .floorMapHeader__datePicker {
    @media (${tablet}) {
      max-width: calc(100vw - 335px);
    }
    @media (${desktop}) {
      max-width: 300px;
    }
  }
  .floorMapHeader__datePicker .weekFlicker__control {
    padding: 8px 0;
  }
`
const Wrapper = styled.div`
  width: 100%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
`

const ChangeOfficeButton = styled(OutlineButton)<any>`
  align-self: center;
  margin-top: 18px;
  @media (${desktop}) {
    display: none;
  }
`

const OfficeInfo = styled.div`
  display: flex;
  flex-direction: column;
  @media (${tablet}) {
    flex-direction: row;
  }
`
